import * as Yup from 'yup';

export class CreatePhysicalDockValidator {
  public get schema() {
    return Yup.object()
      .shape({
        warehouseId: Yup.number()
          .typeError('Informe o id do armazém')
          .required('Informe o id do armazém'),
        buildingId: Yup.number()
          .typeError('Informe o prédio')
          .required('Informe o prédio'),
        number: Yup.number()
          .typeError('Informe o número da doca')
          .integer('Informe um número inteiro para a doca')
          .positive('Informe um número positivo para a doca')
          .required('Informe o número da doca'),
        name: Yup.string().required('Informe o nome da doca'),
        blockedAt: Yup.string()
          .nullable()
          .transform((value) => {
            if (value === '1') return new Date().toISOString();
            return null;
          }),
      })
      .noUnknown();
  }
}
